import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FSObjectListHeader from './FSObjectListHeader';
import FSObjectArchiveListItem from './FSObjectArchiveListItem';
import { sortObjectListItems } from './fsObjectUtils';

import NoItems, { ContentType } from 'components/NoItems';

import { Table } from 'reactstrap';

const StyledTable = styled(Table)`
  table-layout: fixed;
  tbody {
    border: 2px solid transparent;
  }
  th {
    padding: 2rem 0 1rem !important;
  }
  td {
    transition: background 0.2s;
    border-bottom: 1px solid #f0f2f6;
  }

  tbody tr {
    td {
      transition: background 0.2s;
    }
    td svg {
      transition: transform 0.2s;
    }

    &:hover {
      td {
        background: #f5fbff;

        &:first-child {
          svg {
            transform: translateX(5px);
          }
        }

        &:last-child {
          button.btn {
            border: 1px solid #767676;
            transform: translateX(-5px);
          }
        }
      }
    }
  }
`;

const TableWrapper = styled.div`
  .table-responsive {
    min-height: 30vh;
  }
`;

const FSObjectArchiveList = ({
  items,
  eventDashOptionsNode,
  onSortChange,
  sorting,
  onDeleteClick,
  onRestoreClick,
  isLoading,
  onItemClick,
}) => {
  const sortedItems = sortObjectListItems(items, sorting);

  return (
    <TableWrapper>
      <StyledTable>
        <FSObjectListHeader
          {...{ eventDashOptionsNode, onSortChange, sorting }}
        />

        {isLoading && !items.length && (
          <tbody>
            <NoItems type={ContentType.Files} isLoading={isLoading} />
          </tbody>
        )}

        {!items.length && !isLoading && (
          <tbody>
            <NoItems
              title="You don't have anything archived!"
              subTitle="A clean dash is a happy dash."
              type={ContentType.Files}
            />
          </tbody>
        )}

        {items.length > 0 && (
          <tbody>
            {sortedItems.map((item) => (
              <FSObjectArchiveListItem
                key={`fsObjectArchiveListItem-${item._id}`}
                {...{
                  item,
                  onDeleteClick,
                  onRestoreClick,
                  onClick: onItemClick.bind(null, item),
                }}
              />
            ))}
          </tbody>
        )}
      </StyledTable>
    </TableWrapper>
  );
};

FSObjectArchiveList.propTypes = {
  items: PropTypes.array.isRequired,
  optionsNode: PropTypes.element,
  onSortChange: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onRestoreClick: PropTypes.func.isRequired,
  sorting: PropTypes.object.isRequired,
  onItemClick: PropTypes.func.isRequired,
  eventDashOptionsNode: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default FSObjectArchiveList;
